/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector2Tuple } from 'three';

/**
 * Type guard for Vector2Tuple
 */
export const isVector2Tuple = (p: any): p is Vector2Tuple =>
  Array.isArray(p) && p.length === 2 && typeof p[0] === 'number' && typeof p[1] === 'number';
